import { Button, Modal, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { InfinityPagination } from "../hooks/Pagination";
import { ManagerSearch, ManagerTable } from "../interfaces/Manager";
import { RequestCreate } from "../interfaces/Request";
import { ResumeList } from "../interfaces/Resume";
import { VacancySearch, VacancyTable } from "../interfaces/Vacancy";
import {
	CreateRequest,
	GetManagers,
	GetResumes,
	GetVacancies,
} from "../requester/functions";
import { getFullName } from "../utilities/string";
import VO from "../utilities/validate";
import DataMultiSelect from "./DataInputs/DataMultiSelect";
import DataSelect from "./DataInputs/DataSelect";

const template: RequestCreate = {
	id_vacancy: 0,
	id_resume: 0,
};

interface IProps {
	open: boolean;
	onClose(): void;
	onCreate?(): void;
	userId: number;
}

const CreateRequestModal = (props: IProps) => {
	const { enqueueSnackbar } = useSnackbar();

	const [request, setRequest] = useState<RequestCreate>(template);
	const [vacancy, setVacancy] = useState<VacancyTable[]>([]);
	const [managers, setManagers] = useState<ManagerTable[]>([]);
	const [watchers, setWatchers] = useState<ManagerTable[]>([]);

	const [resumes, setResumes] = useState<ResumeList[]>([]);

	const [searchManager, setSearchManager] = useState<ManagerSearch>({});
	const [searchWatcher, setSearchWatcher] = useState<ManagerSearch>({});
	const [searchVacancy, setSearchVacancy] = useState<VacancySearch>({});

	useEffect(() => {
		GetManagers(
			{
				search_by: searchManager,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setManagers(resp.data.data);
				}
			}
		);
	}, [searchManager]);

	useEffect(() => {
		GetManagers(
			{
				search_by: searchWatcher,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setWatchers(resp.data.data);
				}
			}
		);
	}, [searchWatcher]);

	useEffect(() => {
		GetVacancies(
			{
				filter_by: { all_vacancies: true },
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setVacancy(resp.data.data);
				}
			}
		);
	}, [searchVacancy]);

	useEffect(() => {
		GetResumes(
			{
				filter_by: { id_candidate: props.userId },
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setResumes(resp.data.data);
				}
			}
		);
	}, []);

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center flex-col justify-center overflow-auto"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[800px] min-w-[400px] flex flex-col gap-5">
				<Typography variant="h4">Создание заявки</Typography>
				<DataSelect
					label="Вакансия"
					list={vacancy}
					value={request}
					setValue={setRequest}
					keyValue={"id_vacancy"}
				/>
				<DataSelect
					label="Резюме"
					list={resumes}
					value={request}
					setValue={setRequest}
					keyFunction={(option) => "Резюме"}
					keyValue={"id_resume"}
				/>
				<DataSelect
					label="Ответственный"
					list={managers}
					value={request}
					setValue={setRequest}
					keyTitle={"last_name"}
					keyValue={"id_manager"}
				/>
				<DataMultiSelect
					label="Наблюдатели"
					list={watchers}
					value={request}
					setValue={setRequest}
					keyItemValue={"id"}
					keyItemTitle={"last_name"}
					renderItemTitle={(item: ManagerTable) =>
						getFullName(item.last_name, item.first_name, item.patronymic)
					}
					keyValue={"watchers"}
				/>

				<Button
					disabled={!VO(request, template)}
					variant="contained"
					onClick={() => {
						CreateRequest(
							{ id_candidate: props.userId, ...request },
							(resp) => {
								if (resp.status === "ok") {
									enqueueSnackbar("Заявка создана", {
										variant: "success",
									});
									props.onCreate?.();
									props.onClose();
								} else {
									enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
										variant: "error",
									});
								}
							}
						);
					}}
				>
					Сохранить
				</Button>
			</Paper>
		</Modal>
	);
};

export default CreateRequestModal;
